<template>
  <v-card>
    <v-card-title> Details </v-card-title>
    <v-card-text>
      <v-card-text>
        <div class="pa-12">
          <widget-component
            v-if="specimenAdditionalInfo"
            :widgetMetadata="getValidWidgetJSON(specimenAdditionalInfo)"
          >
          </widget-component>
        </div>
      </v-card-text>
    </v-card-text>
  </v-card>
</template>

<script>
import WidgetComponent from '../../../components/ui/WidgetComponent.vue';

import FormService from '../../../services/medical_registry/form.service';

export default {
  name: 'SpecimenAdditionalInfoView',
  components: {
    WidgetComponent,
  },
  props: {
    specimenAdditionalInfo: Object,
  },
  methods: {
    getValidWidgetJSON(specimenAdditionalInfo) {
      console.log('specimenAdditionalInfo', specimenAdditionalInfo);
      return FormService.getValidWidgetJSON(specimenAdditionalInfo);
    },
  },
};
</script>
